@if (loading) {
    <div class="container-loading is-flex is-justify-content-center is-align-items-center">
        <div class="loading"></div>
    </div>
}
@if (articles) {
    @if (headline) {
        <h2 class="subtitle">{{ headline }}</h2>
    }
    <p-carousel #carousel (onPage)="WCAGCleaner()" [numVisible]="5" [numScroll]="5" [value]="articles"
                [showIndicators]="false" [attr.aria-label]="'carousel-' + carouselId"

                [responsiveOptions]="carouselArticleRecommendationsOptions">
        <ng-template let-article pTemplate="item">
            @if (!withoutArticleNumbers.includes(article.articleNumber)) {
                <ng-container>
                    <div class="mx-2" style="height: 100%;">
                        <iw-shop-article-template-gallery [article]="article"></iw-shop-article-template-gallery>
                    </div>
                </ng-container>
            }
        </ng-template>
    </p-carousel>

}


